import React from "react";

function Footer() {
  return (
    <div className="footer-container">
      <h4>SanghyeonHan</h4>
      <p>{`Designed by Sanghyeon & Chaehui`}</p>
    </div>
  );
}

export default Footer;
